import script from "./courseInformation.vue?vue&type=script&setup=true&name=courseInformation&lang=js"
export * from "./courseInformation.vue?vue&type=script&setup=true&name=courseInformation&lang=js"

import "./courseInformation.vue?vue&type=style&index=0&id=74445ac4&scoped=true&lang=css"

import exportComponent from "D:\\Jawsro\\company\\虎鲸\\v3\\hujing_pro_h5\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-74445ac4"]])

export default __exports__